import React from 'react';
import iconAudio from '@/assets/icons/audio.svg';
import playIcon from '@/assets/icons/play-solid.svg';

const AudioPlayer: React.FC<{
  audioRef: React.RefObject<HTMLAudioElement>;
  isPlaying: boolean;
  togglePlay: () => void;
  campaignResource: string;
}> = ({ audioRef, isPlaying, togglePlay, campaignResource }) => (
  <div className="w-full h-full">
    <div className="flex flex-col items-center justify-center h-full text-gray-600">
      <div className="text-6xl">
        <img src={iconAudio} alt="Audio Icon" />
      </div>
    </div>
    <audio
      ref={audioRef}
      controls
      className="opacity-0"
      src={campaignResource}
    ></audio>
    <div
      className="cursor-pointer absolute bottom-[5.58px] left-[5.58px] text-[13.39px] text-white px-3 py-1 text-sm rounded"
      onClick={togglePlay}
    >
      {isPlaying ? (
        <i className="pi pi-pause" />
      ) : (
        <img src={playIcon} alt="Play Icon" />
      )}
    </div>
  </div>
);

export default AudioPlayer;
